const getLocal = (key) => {
  return localStorage.getItem(key);
};

const setLocal = (key, value) => {
  localStorage.setItem(key, value);
};

export default getLocal;

export { setLocal };
